<template>
  <div class="main_center" style="margin: 0 0;padding-top: 8px;">

    <div class="content" style="padding: 10px 10px 0 10px;">

      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-col :span="6"  props="personName">
            <el-form-item label="姓名：">
              <el-input v-model="form.personName" clearable  @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="角色：" props="personRole">
              <el-select v-model="form.personRole" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value="-1"></el-option>
                <el-option v-for="(item,index) in personRoleList" :key="index" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="进出标记：" props="inoutFlag" v-if="moreSearchItem">
              <el-select v-model="form.inoutFlag" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value="-1"></el-option>
                <el-option v-for="(item,index) in inoutFlagList" :key="index" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发生门禁：" props="guardId" v-if="moreSearchItem">
              <el-select v-model="form.guardId" clearable value-key="id" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value="-1"></el-option>
                <el-option v-for="(item,index) in guardListData" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="" v-if="!moreSearchItem">
                <div >
                    <el-button size="small" type="primary"  @click="seachBtn">搜索</el-button>
                    <el-button plain size="small" type="primary" style="margin-left:10px;"  @click="reflash">重置</el-button>
                    <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true" >| 展开</el-button>
                    <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false" >| 收起</el-button>
                </div>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="交易中心：" v-if="moreSearchItem">
              <el-select v-model="form.tradeId" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发生时间：" v-if="moreSearchItem">
              <el-date-picker
                      style="width: 100%"
                      v-model="datetimerange"
                      @change="seachBtn"
                      clearable
                      type="datetimerange"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="" v-if="moreSearchItem">
                <div >
                    <el-button size="small" type="primary"  @click="seachBtn">搜索</el-button>
                    <el-button plain size="small" type="primary" style="margin-left:10px;"  @click="reflash">重置</el-button>
                    <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true" >| 展开</el-button>
                    <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false" >| 收起</el-button>
                </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="position: relative;top:-10px">
        <el-button size="small" v-if="deleteBtnShow" icon="el-icon-delete" type="primary"
                   @click="deleteSelectItem()">批量删除
        </el-button>
        <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                   @click="selectAll(true)">全选
        </el-button>
        <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                   @click="selectAll(false)">反选
        </el-button>
        <el-button size="small" v-if="hasBtnPermission('btn_dgwitness_guard_witness_delete')" :icon="deleteBtnShow?'el-icon-close':'el-icon-delete'" type="primary"
                   @click="triggerDeleteBtn">{{deleteBtnShow?'取消':'删除数据'}}
        </el-button>
      </div>

      <space :left="-16" :right="-16" :bottom="16" />


      <el-row :gutter="15" :style="{'min-height':tableMaxHeight}" v-loading="dataListLoading">
        <el-col :span="8" v-for="item in personList" :key="item.id">
          <el-card class="projectCard" >
            <div class="processStatus">
              <img :src="statusIn" v-if="item.inoutFlag == 1">
              <img :src="statusOut" v-if="item.inoutFlag == 2">
              <img :src="illegal" v-if="item.inoutFlag == 3">
            </div>
            <p class="deleteBtn" v-if="deleteBtnShow">
              <i :style="{'color':hasSelect(item.id)?'#5cb6ff':'#c0c4cc'}"  @click="triggerSelectItem(item.id)" :class="hasSelect(item.id)?'el-icon-circle-check':'el-icon-circle-close'"></i>
            </p>
            <div class="dataWrapper" >
              <img class="personHead" :src="require('@/assets/images/load_error.png')" v-real-img="item.attachments && item.attachments[0] && item.attachments[0].filePath" >
              <div class="infoWrapper">
                <p style="margin-top: 0">
                  <span class="personName" >{{ item.personName }}</span>
<!--                  <span class="roleName" >{{ item.personRoleName }}</span>-->
                  <el-tag :type="formatterTagType(item.personRole,'personRole')" size="small" :hit="false"
                          effect="plain"> {{ formatterDataDictionary(personRoleList,item.personRole)}}
                  </el-tag>
<!--                  <span :class="formatterClass(item)">【{{ item.inoutFlagName }}】</span>-->
                </p>
                <p><span >{{item.idcard}}</span></p>
                <p class="info" ><span>发生门禁：</span><span >{{item.guardName}}</span></p>
                <p class="info"><span>发生时间：</span><span >{{item.createTime}}</span></p>
<!--                <el-button size="small" plain type="primary" title="查看"  @click="showDetail(item.id)">查看</el-button>-->
<!--                <el-button  size="small" plain type="primary" title="删除"  @click="deleteById(item.id)" style="margin-left: 20px;">删除</el-button>-->
              </div>
              <div style="clear: both"></div>
            </div>
          </el-card>
        </el-col>
        <emptyInfo v-if="personList.length == 0" :emptyMsg="'暂无记录'" ></emptyInfo>
      </el-row>
      <!-- <el-pagination
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="pageIndex"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="total"
              layout="sizes, prev, pager, next">
      </el-pagination> -->
      <pagination
            class="limit"
            :page-sizes="[10, 20, 50, 100]"
            :total="total"
            :page.sync="pageIndex"
            :limit.sync="pageSize"
            @pagination="paginationChange">
        </pagination>
    </div>
  </div>
</template>

<script>
    import emptyInfo from '@/components/empty-info';
    import {mapState} from "vuex";
    import space from '../../common/components/space.vue';
    import Pagination from '@/components/Pagination.vue';

    export default {
  components: {
    emptyInfo,
    space,
    Pagination
  },
  data() {
    return {
      tableMaxHeight: (document.documentElement.clientHeight - 267) + 'px',
      dataListLoading: false,
      moreSearchItem:false,
      personRoleList: [],
      inoutFlagList: [],
      datetimerange: [],
      guardListData: [],
      deleteBtnShow:false,
      selectDeleteList:[],
      form: {
        personName: '', //姓名
        personRole: '', //角色
        inoutFlag: '', //进出标记 1进 2出 3非法
        guardId: '', //门禁id
        tradeId: '', // 交易中心ID
      },
      statusOut:require('@/assets/images/out.png'),
      statusIn:require('@/assets/images/in.png'),
      illegal:require('@/assets/images/illegal.png'),
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {},
      personList: [],
      transactionCenterList: [],
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  created() {
    this.getDic('jz_dgwitness_person_role');
    this.getDic('jz_dgwitness_guard_inout');
    this.getGuardList();
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
  },
  activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    // this.reflash()
    this.getDataList()


    //this.getDataList();
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {

      let hasBtnPermisson = this.hasBtnPermission("btn_jz_witness_record_delete");
      let tableMaxHeight = ( document.documentElement.clientHeight - 350 +  (hasBtnPermisson ? 0 : 33) ) + 'px';
      this.pageIndex = 1
      if(document.documentElement.clientHeight >900){
        this.pageSize = 12
      }else if(document.documentElement.clientHeight < 770){
        this.pageSize = 8
      }else{
        this.pageSize = 8
      }
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      // this.getDataList()

    },

    triggerDeleteBtn(){
      this.deleteBtnShow = !this.deleteBtnShow;
      this.selectDeleteList = [];
    },
    hasSelect(id){
      let index = this.selectDeleteList.indexOf(id);
      return index > -1
    },
    triggerSelectItem(id){
      let index = this.selectDeleteList.indexOf(id);
      if(index > -1){
        this.selectDeleteList.splice(index,1);
      }else{
        this.selectDeleteList.push(id)
      }
    },

    selectAll(flag){
      const that = this;
      this.personList.forEach(item=>{
        let index = that.selectDeleteList.indexOf(item.id)
        if(flag && index == -1){
          that.selectDeleteList.push(item.id)
        }
        if(!flag){
          that.triggerSelectItem(item.id)
        }
      })
    },

    deleteSelectItem() {
      if (this.selectDeleteList.length > 0) {

        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$http.post('/guardWitness/delete',{
            idList:this.selectDeleteList
          }).then(res => {
            if (res.data.code == '1') {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getDataList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }
    },


    getGuardList() {//门禁下拉框
      this.$http.post('/sysGuardConfig/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
      }).then(res => {
        this.guardListData = res.data.rows;
        this.total = res.data.total;
      })
    },

    formatterClass(item){

      switch(item.inoutFlag){
        case 1: return 'inoutflag green'; break;
        case 2: return 'inoutflag blue'; break;
        case 3 : return 'inoutflag danger'; break;
        default:return 'inoutflag';break;
      }


    },



    getDataList() { // 获取列表数据
      this.dataListLoading=true;
      this.$http.post('/guardWitness/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'filter':
            {
              personName: this.form.personName, //姓名
              personRole: this.form.personRole == "-1" ? "" : this.form.personRole, //角色
              inoutFlag: this.form.inoutFlag == "-1" ? "" : this.form.inoutFlag, //进出标记 1进 2出 3非法
              guardId: this.form.guardId == "-1" ? "" : this.form.guardId, //门禁id
              tradeId: this.form.tradeId == "-1" ? "" : this.form.tradeId, //交易中心id
              createTimeGE: this.datetimerange[0] ? this.datetimerange[0] : "",
              createTimeLT: this.datetimerange[1] ? this.datetimerange[1] : ""
            }
      }).then(res => {
        this.dataListLoading=false;
        this.personList = res.data.rows;
        this.total = res.data.total;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seachBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    reflash() {//刷新按钮
      this.pageIndex = 1;
      this.$refs['form'].resetFields();

      this.form.personName = ""
      this.form.personRole = "-1"
      this.form.inoutFlag = "-1"
      this.form.guardId = "-1"
      this.datetimerange = []

      this.getDataList()

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/guardWitness/delete', {
          id: item
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      })
    },


    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
    },

    getDic(type) { // 获取字典

      this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_person_role':
              this.personRoleList = res.data.data;
              break;
            case 'jz_dgwitness_guard_inout':
              this.inoutFlagList = res.data.data;
              break;
          }
        }
      })
    },

    showDetail(id) {
      window.sessionStorage.setItem("id", id);
      window.sessionStorage.setItem("addUpdateIndex",1)

      this.$router.push({
        name: "guard_witness_view",
      });
    }


  }


}
</script>

<style lang="less" scoped>


  .main_center{
    .projectCard{

      padding: 14px;
      position: relative;
      /deep/ .el-card__body{
        padding: 0;
      }
      /deep/ .el-card__header{
        padding: 16px 16px 0px 16px;
      }

      .processStatus{
        top: -6px;
        right: -20px;
        img{
          opacity: 1;
          width:60%;
        }
      }

      .info{
        margin: 10px 0px;
      }

      .dataWrapper{

        .personHead{
          width: 110px;
          float:left;
          border:1px solid #dcdfe6
        }
        .infoWrapper{
          width: calc(100% - 120px);float:right;;margin-left: 10px;
          .inoutflag{
            font-size: 22px;
            display: inline-block;
            float: right;
          }
          span.green{
            color: green;
          }
          span.blue{
            color: blue;
          }
          span.danger{
            color: red;
          }
          span.personName{
            font-size: 22px;
            margin-right: 10px;
          }
          span.roleName{
            margin-left: 16px;
          }

        }
      }



    }
  }

</style>